import { render } from "./FormFieldCheckbox.vue?vue&type=template&id=8126b046&scoped=true"
import script from "./FormFieldCheckbox.vue?vue&type=script&lang=js"
export * from "./FormFieldCheckbox.vue?vue&type=script&lang=js"

import "./FormFieldCheckbox.vue?vue&type=style&index=0&id=8126b046&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8126b046"]])

export default __exports__